import React from 'react';

import thunderIcon from '../../../assets/redThunder.png';

export const ThunderIcon = (size) => {
    return (
        <img src={thunderIcon} alt="thunder icon" className="thunder_icon" style={{ width: size + 'px' }} />
    );
};
